<template>
  <v-autocomplete
    :items="filter_items(filter)"
    v-model="val"
    :label="label || title"
    :item-text="item => item.title || item.name"
    item-value="id"
  ></v-autocomplete>
</template>
  
<script>
import SettingsModel from '@/models/settings.js';


export default {
	props: [
		'name',
		'value',
		'label',
    'title',
    'filter'
	],
  methods: {
    filter_items (filter) {
      return SettingsModel.list(filter);
    },
  },  
	computed: {
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>